import { StyleSystemProps } from '@withjoy/joykit';

export const rowContainerStles: StyleSystemProps = {
  typographyVariant: 'label1',
  alignItems: 'center',
  columnGap: 5
};

export const rowProgressBarStyles: StyleSystemProps = {
  position: 'relative',
  borderRadius: 'full',
  flex: 2,
  height: 4,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  _after: {
    position: 'absolute',
    display: 'block',
    height: '100%',
    content: '" "',
    backgroundColor: 'black',
    // width: `${percentage * 100}%`,
    borderRadius: 'inherit'
  }
};

export const chartGroupStyles: StyleSystemProps = {
  marginTop: [8, null, 10],
  flexDirection: ['column', null, 'row'],
  rowGap: 8,
  columnGap: 10,
  flexWrap: 'wrap',
  maxWidth: [350, null, 800]
};
